import React from "react";
import { motion } from "framer-motion";
import "./PartnershipModels.css";
import { useLanguage } from "../../contexts/LanguageContext";
import { FaUserSecret, FaHandshake, FaChartLine, FaCoins } from "react-icons/fa";
import { GiProgression } from "react-icons/gi";

const PartnershipModels = () => {
  const { translations: tRaw } = useLanguage();
  const t = {
    investment: {},
    ...tRaw,
    investment: { ...tRaw?.investment },
  };

  const models = [
    {
      icon: <FaUserSecret className="model-icon-svg" />,
      title: t.investment?.models?.silent?.title || "Normal Investor",
      desc:
      t.investment?.models?.silent?.desc ||
      "A guaranteed investment option that ensures fixed annual returns with no operational responsibilities.",
      perks: [
        t.investment?.models?.silent?.perks?.[0] || "Fixed annual return based on investment tier",
      t.investment?.models?.silent?.perks?.[1] || "No need to manage or be involved operationally",
      t.investment?.models?.silent?.perks?.[2] || "Secure, legally protected contracts",
      t.investment?.models?.silent?.perks?.[3] || "Only a limited number of investment seats available"
      ],
      accent: "#0088ff"
    },
    {
      icon: <FaHandshake className="model-icon-svg" />,
      title: t.investment?.models?.equity?.title || "Equity Partner",
       desc:
      t.investment?.models?.equity?.desc ||
      "A strategic partnership model granting ownership rights and future profit shares based on app performance.",
      perks: [
      t.investment?.models?.equity?.perks?.[0] || "Shareholder rights and equity ownership",
      t.investment?.models?.equity?.perks?.[1] || "Benefit from long-term app valuation growth",
      t.investment?.models?.equity?.perks?.[2] || "Participation in future profit distributions",
      t.investment?.models?.equity?.perks?.[3] || "Priority in upcoming investment rounds"
      ],
      accent: "#00d4ff"
    },
    // {
    //   icon: <GiProgression className="model-icon-svg" />,
    //   title: t.investment?.models?.hybrid?.title || "Hybrid Model",
    //   desc: t.investment?.models?.hybrid?.desc || "Combine fixed returns with equity participation.",
    //   perks: [
    //     t.investment?.models?.hybrid?.perks?.[0] || "Base + performance returns",
    //     t.investment?.models?.hybrid?.perks?.[1] || "Reduced risk exposure",
    //     t.investment?.models?.hybrid?.perks?.[2] || "Flexible terms"
    //   ],
    //   accent: "#ff6600"
    // }
  ];

  return (
    <section className="partnership-models-section">
      {/* Decorative elements */}
      {/* <div className="models-decorative-circle"></div> */}
      <div className="models-decorative-dots"></div>
      
      <motion.div
        className="models-container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="models-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* <span className="models-pre-title">
            {t.investment?.modelsSubtitle || "Flexible Investment Options"}
          </span> */}
          <h2 className="models-title">
            {t.investment?.modelsTitle || "Partnership Models"}
          </h2>
          <p className="models-intro">
            {t.investment?.modelsIntro || "Choose the investment approach that aligns with your financial goals and involvement preferences."}
          </p>
        </motion.div>

        <div className="models-grid">
          {models.map((model, idx) => (
            <motion.div
              key={idx}
              className="model-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -10 }}
              transition={{ 
                duration: 0.5, 
                delay: idx * 0.15,
                ease: [0.16, 1, 0.3, 1]
              }}
              style={{ '--accent-color': model.accent }}
            >
              <div className="model-icon-container">
                {model.icon}
              </div>
              <h3 className="model-title">{model.title}</h3>
              <p className="model-desc">{model.desc}</p>
              
              <div className="model-perks">
                {model.perks.map((perk, i) => (
                  <div key={i} className="model-perk">
                    <span className="perk-bullet"></span>
                    <span>{perk}</span>
                  </div>
                ))}
              </div>
              
              {/* <div className="model-cta">
                <button className="model-button">
                  {t.investment?.learnMore || "Learn More"}
                </button>
              </div> */}
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default PartnershipModels;